import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w100 llgreyBg pad15 rad20 posRe"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "mt7 mb1",
  style: {}
}, "編集", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  role: "button",
  class: "mt5 mb1",
  style: {}
}, "交換", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(`dgrey fr posRe fw600 mr10 mt5`),
  style: {}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = {
  key: 0,
  class: "fl fs13 fw600 ml40"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { class: "" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "mt3 fs18 fw600" }, "表示日程を細かく設定", -1)
const _hoisted_16 = { class: "mt1 fs13 fw600 arial" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = { class: "fl" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mt3 fs18 fw600" }, "調整可能時間・期間の設定", -1)
const _hoisted_20 = { class: "mt1 fs13 fw600 arial" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconGear = _resolveComponent("IconGear")!
  const _component_CalendarIcon = _resolveComponent("CalendarIcon")!
  const _component_IconRefresh = _resolveComponent("IconRefresh")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.rcm.astag)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_IconGear, {
          width: 33,
          class: "fl",
          tooltipText: `表示する日程候補を設定します`
        }),
        (!_ctx.rcm.room.is_shared_chukai)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fr borderGrey rad15 centered pointer hoverLgreyBg with_white_bg",
              style: {"padding":"5px 10px","margin-top":"-7px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickEditCurrentAstag && _ctx.clickEditCurrentAstag(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/editPen.png`),
                width: "19",
                height: "19",
                class: "mt6",
                style: {}
              }, null, 8, _hoisted_2),
              _hoisted_3,
              _hoisted_4
            ]))
          : _createCommentVNode("", true),
        (_ctx.rcm.room.is_owner)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "fr borderGrey rad15 centered pointer mr10 hoverLgreyBg with_white_bg",
              style: {"padding":"5px 10px","margin-top":"-7px"},
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickEditable && _ctx.clickEditable(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/change.png`),
                width: "22",
                height: "22",
                class: "mt5",
                style: {}
              }, null, 8, _hoisted_5),
              _hoisted_6,
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_CalendarIcon, {
            astag: _ctx.rcm.astag,
            width: 40,
            iconWidth: 40,
            totalHeight: 40,
            canDelete: false,
            hideName: true,
            hideBorder: true,
            classes: `fl mt3`,
            showSharedInfo: false,
            onClick: _ctx.clickEditable
          }, null, 8, ["astag", "onClick"]),
          _createElementVNode("p", {
            class: "fl mt13 fs14 fw600",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickEditable && _ctx.clickEditable(...args)))
          }, " 「" + _toDisplayString(_ctx.truncate(_ctx.rcm.astag.name, 18)) + "」の調整カレンダーを利用しています ", 1),
          _hoisted_9,
          (_ctx.rcm.subAstag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, "└ " + _toDisplayString(_ctx.truncate(_ctx.rcm.subAstag.name, 18)), 1))
            : _createCommentVNode("", true)
        ])), [
          [_directive_tooltip, _ctx.tooltipName]
        ]),
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_IconRefresh, {
            tooltipText: `カレンダーを更新`,
            onRefresh: _ctx.refreshPreviewSchedule,
            showTooltip: _ctx.showTooltip,
            loading: _ctx.gettingPds,
            class: "fl"
          }, null, 8, ["onRefresh", "showTooltip", "loading"]),
          _createElementVNode("div", {
            class: _normalizeClass(`fr w45 rad10 borderGrey hoverSkyblue dgrey mt20 pointer with_white_bg`),
            style: {"padding":"8px 20px"},
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickEditRoomSetting && _ctx.clickEditRoomSetting(...args)))
          }, [
            _createElementVNode("img", {
              src: _ctx.$getAssetImageUrl(`/assets/icons/setting_sliders.png`),
              width: "26",
              height: "28",
              class: "mt8 mr20 fl",
              style: {}
            }, null, 8, _hoisted_13),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.settingDetailText), 1)
            ]),
            _hoisted_17
          ]),
          _createElementVNode("div", {
            class: "fr w45 rad10 borderGrey hoverSkyblue dgrey mt20 pointer with_white_bg mr20",
            style: {"padding":"8px 20px"},
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clickEditTimeSpan && _ctx.clickEditTimeSpan(...args)))
          }, [
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.periodText), 1)
            ])
          ]),
          _hoisted_21
        ]),
        _hoisted_22
      ]))
    : _createCommentVNode("", true)
}